export const toFixedExceptInt = (num: number, fixPos: number) => (Number.isInteger(num) ? num : num.toFixed(fixPos));

/**
 * 小数转百分比，最大 100%
 */
export const decimal2Percentile = (decimal: number, len = 3, fullFlag = true, isUnit = true) => {
  if (isNaN(decimal)) {
    return 'NaN';
  }
  const percentile = decimal * 100;
  if (percentile >= 100 && fullFlag) {
    return '100%';
  }
  if (percentile >= 100) {
    return '100';
  }

  return `${toFixedExceptInt(percentile, len)}${isUnit ? '%' : ''}`;
};

/**
 * 小数转万分比
 */
export const decimalPermyriad = (decimal: number, len = 4, fullFlag = true) => {
  if (isNaN(decimal)) {
    return 'NaN';
  }
  const percentile = decimal * 10000;
  if (percentile >= 10000 && fullFlag) {
    return '100%';
  }

  return `${toFixedExceptInt(percentile, len)}‱`;
};

// 上报量坐标
export function formatCount(count: number[]) {
  let unit = '';
  let divider = 1;

  if (!count || count.length === 0) {
    return {
      unit,
      count: [],
    };
  }

  const filterArr = count.filter(item => item !== null && !isNaN(item));
  if (filterArr.length === 0) {
    return {
      unit,
      count,
    };
  }

  const max = Math.max(...filterArr);

  if (max >= 1000 && max < 10000) {
    unit = '千';
    divider = 1000;
  }
  if (max >= 10000 && max < 1000000) {
    unit = '万';
    divider = 10000;
  }
  if (max >= 1000000 && max < 100000000) {
    unit = '百万';
    divider = 1000000;
  }
  if (max >= 10000000 && max < 100000000) {
    unit = '千万';
    divider = 10000000;
  }
  if (max >= 100000000) {
    unit = '亿';
    divider = 100000000;
  }

  return {
    unit,
    count: count.map(c => (Number.isNaN(c) ? c : Number((c / divider).toFixed(2)))),
  };
}
